// initial state
const state = () => ({
    uploadProgress: null,
    tracks: []
})

// getters
const getters = {
    //
}

// actions
const actions = {
    getTracks: async ({ commit }) => {
        return axios.get('track').then(({ data }) => {
            commit('setTracks', data);
            return data;
        }).catch(({ data }) => {
            throw data || 'Something went wrong';
        });
    },

    updateTrack: async ({ commit }, payload) => {
        try {
            return await axios.put('track/' + payload.id, (({ audioTrack, ...payload}) => payload)(payload));
        } catch (error) {
            throw error.response.data?.message || 'Something went wrong';
        }
        // commit('updateTrack', data);
    },

    // Remove track from scene
    removeTrack: async ({ commit }, payload) => {
        let { data } = await axios.put('track-group/' + payload.pivot.scene_id, {
            remove_tracks: payload.id
        });

        commit('updateScene', data);
    },

    // Delete track from system
    deleteTrack: async ({ commit }, payload) => {
        return await axios.delete('track/' + payload.id).then(() => {
            commit('removeTrack', payload);
        });
    },

    uploadTrack: async ({ commit }, payload) => {
        commit('setUploadProgress', 0);

        try {
            let { data } = await axios.post('track', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress:(progressEvent) => {
                    commit('setUploadProgress', parseInt(Math.round(progressEvent.loaded / progressEvent.total) * 100));
                }
            });

            commit('setUploadProgress', null);
            return data;
        } catch (error) {
            commit('setUploadProgress', null);
            throw error.response.data?.message || 'Something went wrong';
        }
    },

    importYoutube: async ({ commit }, payload) => {
        try {
            return await axios.post('track', { youtube: payload }).then(({ data }) => {
                return data;
            });
        } catch (error) {
            throw error.response.data?.message || 'Something went wrong';
        }
    },

    addLibraryTrack: async ({ commit }, payload) => {
        let { data } = await axios.put('album/' + payload.albumId + '/track/' + payload.trackId, payload);

        commit('addTrack', data);
        return data;
    }
}

// mutations
const mutations = {
    addTrack(state, data) {
        state.tracks.push(data);
    },

    setTracks(state, data) {
        state.tracks = data;
    },

    removeTrack(state, data) {
        let trackIndex = state.tracks.findIndex(track => track.id === data.id);

        if (trackIndex >= 0) {
            state.tracks.splice(trackIndex, 1);
        }
    },

    updateTrack(state, data) {
        let trackIndex = state.tracks.findIndex(track => track.id === data.id);

        if (trackIndex >= 0) {
            state.tracks.splice(trackIndex, 1, data);
        }
    },

    updateMediaPlayer(state, data) {
        data.track.mediaPlayer = data.mediaPlayer;
    },

    updateTrackName(state, data) {
        data.track.name = data.name;
    },

    updateTrackVolume(state, data) {
        if (data.track.pivot) {
            // console.log('update pivot volume');
            data.track.pivot.volume = data.volume;
        } else {
            // console.log('update track volume');
            data.track.volume = data.volume;
        }
    },

    updateTrackStatus(state, data) {
        if (!data.track.pivot) {
            data.track.pivot = {};
        }
        data.track.pivot.status = data.status;
    },

    updateTrackLoopStatus(state, data) {
        if (!data.track.pivot) {
            data.track.pivot = {};
        }

        data.track.pivot.loop = data.loop;
    },

    updateTrackFadeIn(state, data) {
        if (!data.track.pivot) {
            data.track.pivot = {};
        }

        data.track.pivot.fade_in_timer = data.fadeInTimer;
    },

    updateTrackFadeOut(state, data) {
        if (!data.track.pivot) {
            data.track.pivot = {};
        }

        data.track.pivot.fade_out_timer = data.fadeOutTimer;
    },

    updateTrackInterval(state, data) {
        if (!data.track.pivot) {
            data.track.pivot = {};
        }

        if (data.interval_type) {
            data.track.pivot.interval_type = data.interval_type;
        }
        if (data.interval_start) {
            data.track.pivot.interval_start = data.interval_start;
        }
        if (data.interval_stop) {
            data.track.pivot.interval_stop = data.interval_stop;
        }
        if (data.interval_start_type) {
            data.track.pivot.interval_start_type = data.interval_start_type;
        }
        if (data.interval_stop_type) {
            data.track.pivot.interval_stop_type = data.interval_stop_type;
        }
    },

    updateTrackIntervalFormat(state, data) {
        if (!data.track.pivot) {
            data.track.pivot = {};
        }

        data.track.pivot.interval_start_type = data.interval_start_type;
        data.track.pivot.interval_stop_type = data.interval_stop_type;
    },

    setUploadProgress(state, data) {
        state.uploadProgress = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
